import { CSSProperties } from "react";

interface Props {
  margin?: string;
  thickness?: number;
  color?: string;
  style?: CSSProperties;
}

const VerticalLine: React.FC<Props> = ({
  thickness = 0.5,
  color = "var(--divider)",
  margin = "0.25em 1em",
  ...rest
}) => (
  <div
    {...rest}
    style={{
      alignSelf: "stretch",
      borderStyle: "solid",
      borderWidth: 0,
      borderLeftWidth: thickness,
      borderColor: color,
      backgroundColor: color,
      margin: margin,
      ...rest.style,
    }}
  />
);
export { VerticalLine };
